
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Manubar from "./Manubar";
import Security from "./Security";
import Footer from "./Footer";
import axios from "axios";
import "./loader.css";
import "./Aboutus.css";

/* Line heading hai ya nahi:
   - "1. Introduction:" jaise number se shuru hone wali chhoti line
   - ya chhoti line jo ":" par khatam ho (Declaration:, Cashback Service:) */
const isHeading = (line) => {
  const text = line.trim();
  if (!text || text.length > 90) return false;
  return /^\d+\.\s+\S/.test(text) || /:$/.test(text);
};

/* Markdown link [text](url) ko sirf text bana do */
const cleanLine = (line) =>
  line.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, "$1").trim();

const RenderDescription = ({ text }) => {
  const lines = String(text || "")
    .split(/\r?\n/)
    .map(cleanLine)
    .filter((line) => line !== "");

  return lines.map((line, i) =>
    isHeading(line) ? (
      <h3 key={i} className="aboutus-subheading">
        {line}
      </h3>
    ) : (
      <p key={i} className="aboutus-text text-start">
        {line}
      </p>
    )
  );
};

const TermsAndCondition = () => {

  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getTerms() {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API}website/terms_and_condition`
      );

      setTerms(res?.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getTerms();
  }, []);

  return (
    <div className="aboutus-page">

      {/* Mobile Menu */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center flex-wrap">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  Terms & Conditions
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Content Section */}
      <section className="about-section section-mt section-mb">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-12 col-xl-10">

              <div className="about-content aboutus-content">

                {loading ? (

                  <div className="aboutus-loader-wrap">
                    <div className="loader"></div>
                  </div>

                ) : terms.length === 0 ? (

                  <p className="aboutus-empty">
                    No information available right now.
                  </p>

                ) : (

                  terms.map((item, idx) => (
                    <div key={idx} className="aboutus-block">
                      <h2 className="title aboutus-title">
                        {item?.title}
                      </h2>

                      <RenderDescription text={item?.description} />
                    </div>
                  ))

                )}

              </div>

            </div>

          </div>
        </div>
      </section>

      <Security />
      <Footer />

    </div>
  );
};

export default TermsAndCondition;